import React from 'react';
import { ICON_MAP, SYMBOL_MAP } from 'site-modules/shared/constants/upper-funnel/car-icons-svg-map';

export const getIcon = type => {
  if (ICON_MAP[type]) return ICON_MAP[type];
  return ICON_MAP.default;
};

export const mapTypeIconSymbol = () => SYMBOL_MAP.map(symbol => symbol);

export const getTypeIconSymbol = <svg xmlns="http://www.w3.org/2000/svg">{mapTypeIconSymbol()}</svg>;
